import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import cssVariables from "../../theme/cssVariables";
import planningImg from "../../assets/images/home/planning.svg";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));

const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
});

function BarLegend(props) {
    const { data, colors } = props
    let row = [];
    let percent = (data) => {
        let sumpercent = 0
        if (data > 0) {
            sumpercent = ((data / props.totalScore) * 100)
        }
        return sumpercent.toFixed(2)
    }
    for (var i = 0; i < data.series.length; i++) {
        row.push(
            <Box key={data.series[i].id} display="flex" alignItems="center">
                <Box sx={{ width: "5%" }}>
                    <div className="bar-legend-circle" style={{ backgroundColor: colors[i] }}></div>
                </Box>
                <Box sx={{ width: "50%" }}><Typography variant="label" style={styles.barLegend} fontWeight={300}> {data.series[i].name}</Typography></Box>
                <Box sx={{ width: "15%" }}><Typography variant="label" style={styles.barLegend} fontWeight={500}> {data.series[i].data[0]}</Typography></Box>
                <Box sx={{ width: "15%" }}><Typography variant="label" style={styles.barLegend} fontWeight={300}> {data.options.unit}</Typography></Box>
                <Box sx={{ width: "15%" }}><Typography variant="label" style={styles.barLegend} fontWeight={300}>({percent(data.series[i].data[0])}%)</Typography></Box>
            </Box>
        );
    }
    return (row)
}

export default function PAPortion(props) {
    const { t } = useTranslation();
    const { datas, dataPA, checkAdd } = props;
    const classes = useStyles();
    const [typeList, setTypeList] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    const [colorBar, setColor] = React.useState([]);
    const [dataBarChart, setDataBarChart] = React.useState([]);
    useEffect(() => {
        mapping()
    }, [datas]);
    useEffect(() => {
        mapping()
    }, [checkAdd]);
    let sumScore = (data) => {
        let totals = 0
        data.rb_condition.map((data) => { totals = totals + calculateScore(data) })
        return totals
    }
    let totalScore = () => {
        let totals = 0
        if (typeList.length > 0) {
            typeList.map((data) => { totals = totals + Number(data?.data[0]) })
        }
        return totals.toFixed(2)
    }
    let calculateScore = (data) => {
        let sum = eval(data.calculate_score)
        let scores = Number.isNaN(Number(sum)) ? 0 : Math.round(sum * 100) / 100
        return scores
    }
    let sumScoreAccumulateUse = (data) => {
        let totals = data?.accumulate_use !== undefined && data?.accumulate_use !== null && data?.accumulate_use !== "" ? Number.isNaN(Number(data?.accumulate_use)) ? 0 : Math.round(data?.accumulate_use * 100) / 100 : 0
        for (let index = 0; index <= data.rb_condition.length - 1; index++) {
            totals = totals + Number(calculateScore(data.rb_condition[index]))
        }
        return Number.isNaN(Number(totals)) ? 0 : Number(totals).toFixed(2)
    }
    const mapping = () => {
        if (datas !== undefined && datas !== null && datas !== "null") {
            var typeData = []
            var score = 0
            let colors = []
            let sumData = []
            for (let index = 0; index <= datas.length - 1; index++) {
                for (let indexs = 0; indexs <= dataPA.ratio_data.length - 1; indexs++) {
                    if (dataPA.ratio_data.length > 0) {
                        if (datas[index].serial === Object.keys(dataPA.ratio_data[indexs])[0]) {
                            score = datas[1].accumulate_use
                            typeData.push({ name: datas[index].description, data: [sumScoreAccumulateUse(datas[index])] })
                            sumData.push({
                                name: datas[index]?.description,
                                data: [sumScoreAccumulateUse(datas[index])],
                                accumulate_use: score,
                                is_accumulate: datas[index]?.is_accumulate,
                                configuration: datas[index]?.configuration
                            })
                            let criterionScore = dataPA.ratio_data[indexs][Object.keys(dataPA.ratio_data[indexs])].criterion_score
                            setCriterionScore(Number.isNaN(Number(criterionScore)) ? 0 : Number(criterionScore));
                            colors.push(JSON.parse(datas[index].configuration)['background-color'])
                        }

                    }
                }
            }
            setTypeList(typeData)
            setScore(score)
            setColor(colors)
            setDataBarChart(sumData)
        }
    }
    let chartOptions = {
        type: "bar",
        series: typeList,
        options: {
            unit: "คะแนน",
            chart: {
                type: "bar",
                stacked: true,
                stackType: "100%",
                toolbar: {
                    show: false,
                },
                offsetX: 0,
                offsetY: 0
            },

            colors: [],
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 5,
                    barHeight: "100%",
                    colors: {
                        ranges: [{
                            from: 0,
                            to: 0,
                            color: '#F0F0F0'
                        }],
                        backgroundBarColors: ['#F0F0F0'],
                        backgroundBarOpacity: 1,
                        backgroundBarRadius: 0,
                    },
                },
            },
            grid: {
                show: false,
                padding: {
                    top: -50,
                    right: 0,
                    bottom: -10,
                    left: -20
                },
            },
            stroke: {
                width: 1,
                colors: ["#fff"],
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                x: {
                    show: false,
                },
                y: {
                    formatter: function (val) {
                        return val + " คะแนน";
                    },
                },
            },
            fill: {
                opacity: 1,
                // type: ['solid', 'gradient'],
                // colors: '#F0F0F0'
            },
            legend: {
                show: false,
                position: "bottom",
                horizontalAlign: "left",
                offsetX: -33,
                offsetY: -55,
                formatter: function (val, opts) {
                    const roundToHundred = (arr) => {
                        let output = [];
                        let acc = 0;
                        for (let i = 0; i < arr.length; i++) {
                            let roundedCur = Math.round(arr[i][0]);
                            const currentAcc = acc;
                            if (acc == 0) {
                                output.push(roundedCur);
                                acc += arr[i][0];
                                continue;
                            }
                            acc += arr[i][0];
                            output.push(Math.round(acc) - Math.round(currentAcc));
                        }
                        return output;
                    };
                    let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
                    return (
                        "<span class='fs-12px ml-2'>" +
                        (val ? val : "-") +
                        ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
                        (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                        " (" + (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) + "%)" +
                        "</span>"
                    );
                    // return (
                    //   "<span class='fs-12px ml-2'>" +
                    //   val +
                    //   "</span><span class='fs-12px fw-600 float-right'>" +
                    //   (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0 )+
                    // "% (" +
                    // (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
                    // ")</span>"
                    // );
                },
            },
        },
    };

    return (
        <Box px={2} py={1}>
            {/*<CardContent>*/}
            {/*    <Grid container spacing={0}>*/}
            {/*        <Grid item>*/}
            {/*            <div*/}
            {/*                className={`${classes.iconContainer} ${classes.blueBg}`}*/}
            {/*            >*/}
            {/*                <img src={planningImg} alt="bannerImage"/>*/}
            {/*            </div>*/}
            {/*        </Grid>*/}
            {/*        <Grid item ml={1}>*/}
            {/*            <Grid container spacing={0}>*/}
            {/*                <Grid item>*/}
            {/*                    <Typography fontSize={24} lineHeight={1}>*/}
            {/*                        {t("home.label.paPlanning")}*/}
            {/*                    </Typography>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*            <Grid container spacing={0}>*/}
            {/*                <Grid item p={0}>*/}
            {/*                    <Typography fontSize={14} lineHeight={1}>*/}
            {/*                        แผนการประเมินรอบที่ 1 (เวอร์ชัน1.0)*/}
            {/*                        /!*{t("home.label.title")}*!/*/}
            {/*                    </Typography>*/}
            {/*                </Grid>*/}
            {/*            </Grid>*/}
            {/*        </Grid>*/}
            {/*    </Grid>*/}
            {/*</CardContent>*/}
            {/*<Divider/>*/}
            <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "10px 0" }}>
                {/* <Box>
                      <img src={fileBrowser} alt="browser" />
                    </Box>
                    <Box>
                      <Typography>{t("home.label.nodata")}</Typography>
                    </Box> */}
                <Grid container my={2}>
                    <Grid item lg={6} xs={10}>
                        <Typography fontSize={24} lineHeight="26.4px" fontWeight={500} color="#404349">
                            {t("home.label.planningPortion")}
                        </Typography>
                    </Grid>
                    {Number.isNaN(Number(totalScore())) === false && Number(totalScore()) === 0 ?
                        <Grid item lg={6} xs={2}>
                            <Typography fontSize={20} fontWeight={500} lineHeight="26.4px" textAlign="right" color="#939393">
                                0%
                            </Typography>
                        </Grid>
                        :
                        <Grid item lg={6} xs={2}>
                            <Typography fontSize={20} fontWeight={500} lineHeight="26.4px" textAlign="right" color="#939393">
                                100%
                            </Typography>
                        </Grid>
                    }

                </Grid>
                <Grid container>
                    <Grid item lg={12} xs={12}>
                        <ApexCharts
                            options={{ ...chartOptions.options, colors: colorBar }}
                            series={chartOptions.series}
                            type={chartOptions.type}
                            height="50px"
                        ></ApexCharts>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item lg={8} xs={8}>
                        <Grid container>
                            <Grid item lg={12} xs={12}>
                                <BarLegend data={chartOptions} colors={colorBar} totalScore={totalScore()}></BarLegend>
                                {/* { BarLegend(chartOptions) } */}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={4} xs={4} display="flex" alignItems="flex-start" flexDirection="column">
                        {dataBarChart.length > 0 ?
                            dataBarChart.map((loRow, index) => (
                                loRow.accumulate_use > 0 && loRow.is_accumulate === "y" ?
                                    <Box style={loRow?.configuration !== undefined && loRow?.configuration !== null ? { position: "relative" } : { position: "relative" }}>
                                        <Box>
                                            <Typography fontSize={12} lineHeight="18px" fontWeight={500} sx={{ padding: "2px 5px" }} style={loRow?.configuration !== undefined && loRow?.configuration !== null ? { "background-color": `${JSON.parse(loRow?.configuration)['accumulate-color']}`, "color": `${JSON.parse(loRow?.configuration)['accumulate-color']}`, opacity: "0.15" } : {}}>
                                                ใช้คะแนนสะสม {loRow.accumulate_use} คะแนน
                                            </Typography>
                                        </Box>
                                        <Typography fontSize={12} lineHeight="18px" fontWeight={500} sx={{ padding: "2px 5px" }} style={loRow?.configuration !== undefined && loRow?.configuration !== null ? { position: "absolute", top: 0, "color": `${JSON.parse(loRow?.configuration)['accumulate-color']}` } : {}}>
                                            ใช้คะแนนสะสม {loRow.accumulate_use} คะแนน
                                        </Typography>
                                    </Box>
                                    : <Box>
                                        <Typography fontSize={12} lineHeight="22px" fontWeight={500}>
                                            &nbsp;
                                        </Typography>
                                    </Box>
                            ))
                            : null}
                    </Grid>
                </Grid>
            </CardContent>
            <Divider variant="middle" />
            <CardActions>
                <Grid container mt={0}>
                    <Grid item display="flex" justifyContent="flex-end" sx={{ flexFlow: "column", marginLeft: "auto" }}>
                        <Typography fontSize={16} lineHeight="24px" fontWeight={500} color="#939393" textAlign="right" variant="label" >
                            {/* {t("home.label.title")} */}
                            คะแนนสะสมรวมปัจจุบัน:

                            <Typography pl={2} pr={2} fontSize={20} lineHeight="30px" fontWeight={500} textAlign="right" variant="label" color="primary">{totalScore()}</Typography>

                            คะแนน
                        </Typography>
                        <Typography fontSize={14} fontWeight={300} lineHeight="21px" color="#939393" textAlign="left" variant="label">
                            {/* {t("home.label.title")} */}
                            (ภาระงานขั้นต่ำ {criterionScore} คะแนน)
                        </Typography>
                    </Grid>
                </Grid>
            </CardActions>
        </Box>
    )
}

